interface EditorProps {
  value: string;
  onChange: (value: string) => void;
}

export default function Editor({ value, onChange }: EditorProps) {
  return (
    <div className="w-full h-full border-r-0 md:border-r border-b md:border-b-0 border-gray-200 dark:border-gray-700 flex flex-col bg-white dark:bg-gray-800">
      <div className="h-10 border-b border-gray-200 dark:border-gray-700 flex items-center px-4 bg-gray-50 dark:bg-gray-900">
        <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
          Editor
        </span>
      </div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex-1 w-full p-4 resize-none focus:outline-none bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 editor-textarea custom-scrollbar"
        placeholder="Type your markdown here..."
        spellCheck={false}
      />
    </div>
  );
}
